<template>
    <master-layout>

        <!-- Breadcamb -->
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title m-b-0"><i class="ti-plug"></i> {{ $t('integrations') }} </h4>
                <ol class="breadcrumb">
                    <li><router-link :to="{ name: 'integrations.index' }">{{ $t('integrations') }}</router-link></li>
                    <li class="active">Zapier</li>
                </ol>
            </div>
            <pml-back-button></pml-back-button>
        </div>

        <!-- Infos Integration -->
        <div class="card-box icon_integration">
            <div class="bar-widget m-b-15">
                <div class="table-box">
                    <div class="table-detail w_60">
                        <div class="iconbox">
                            <i class="fa fa-gear"></i>
                        </div>
                    </div>
                    <div class="table-detail">
                        <h5 class="m-t-0 m-b-5 d_inline_b">
                            <b>{{ $t('_integrations.name_zapier') }}</b>
                            <label class="label label-warning m-l-5 m-b-0 pull-right">Beta</label>
                        </h5>
                        <p class="m-b-5 text-muted">{{ $t('_integrations.description_zapier') }}</p>
                    </div>
                </div>
            </div>
            <p>
                {{ $t('_integrations.zapier.line_01') }}<br>
                {{ $t('_integrations.zapier.line_02') }}:
            </p>
            <ul>
                <li><b>{{ $t('create_leads') }}: </b>{{ $t('_integrations.zapier.line_03') }}</li>
                <li><b>{{ $t('export_leads') }}: </b>{{ $t('_integrations.zapier.line_04') }}</li>
            </ul>
            <div class="alert alert_default m-0">
                <strong class="show m-b-5">{{ $t('attention') }}!</strong>
                <p>{{ $t('_integrations.zapier.line_05') }}</p>
                <ul>
                    <li v-html="$t('_integrations.zapier.line_06')"></li>
                    <li>{{ $t('_integrations.zapier.line_07') }}</li>
                    <ul>
                        <li><b>Trigger -</b> {{ $t('_integrations.zapier.line_08') }}</li>
                        <li><b>Action -</b> {{ $t('_integrations.zapier.line_09') }}</li>
                    </ul>
                </ul>
            </div>
            <hr>
            <div v-pml-block="isLoading" v-if="member.is_admin">
                <div v-if="key">
                    <div class="m-b-15">
                        <label>{{ $t('_integrations.zapier.line_10') }}:</label>
                        <div class="input-group">
                            <input class="form-control input_search" :value="key" readonly>
                            <span class="input-group-btn" v-clipboard="key" @success="handleSuccess()">
                            <button class="btn btn-primary" v-pml-tooltip="$t('copy')"><i class="fa fa-copy"></i></button>
                        </span>
                        </div>
                    </div>
                    <div class="clearfix">
                        <button @click.prevent="askTo('disable')" v-pml-block="isDisabling" class="btn btn-white pull-left">{{ $t('disconnect') }}</button>
                        <button @click.prevent="askTo('refresh')" v-pml-block="isRefreshing" class="btn btn-default pull-right">{{ $t('key_update') }}</button>
                    </div>
                </div>
                <div v-else>
                    <div class="text-right">
                        <button @click.prevent="askTo('enable')" v-pml-block="isEnabling" class="btn btn-default">{{ $t('connect') }}</button>
                    </div>
                </div>
            </div>
            <div class="alert alert-danger t_center m-0" v-else>{{ $t('_integrations.zapier.line_11') }}</div>
        </div>

    </master-layout>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { irreversible } from 'utils/helpers/sweet-alert'
    import { getZapier, disableZapier, enableZapier, refreshZapier } from 'services/integrations'
    import { mapGetters } from 'vuex'

    export default {
        name: 'Zapier',
        data () {
            return {
                key: null,
                isDisabling: false,
                isRefreshing: false,
                isEnabling: false,
                isLoading: false
            }
        },
        metaInfo () {
            return {
                title: trans('integrations') + ' | Zapier'
            }
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant',
                'member': 'getMember'
            })
        },
        mounted () {
            if (!['premium_power_sales'].includes(this.tenant.stripePlan))
                this.$router.push({ name: 'error.404' })

            this.isLoading = true

            getZapier()
                .then(response => { this.key = response.data })
                .catch(() => { Notify.error(trans('_notifications.error')) })
                .then(() => { this.isLoading = false })
        },
        methods: {
            handleSuccess () {
                Notify.info(trans('info_added_to_your_clipboard'))
            },
            askTo (method) {
                irreversible()
                    .then((response) => (response.value) ? this[method]() : null)
            },

            disable () {
                this.isDisabling = true

                disableZapier()
                    .then(() => { this.key = null })
                    .catch(() => { Notify.error(trans('_notifications.error')) })
                    .then(() => { this.isDisabling = false })
            },
            enable () {
                this.isEnabling = true

                enableZapier()
                    .then(response => { this.key = response.data })
                    .catch(() => { Notify.error(trans('_notifications.error')) })
                    .then(() => { this.isEnabling = false })
            },
            refresh () {
                this.isRefreshing = true

                refreshZapier()
                    .then(response => { this.key = response.data })
                    .catch(() => { Notify.error(trans('_notifications.error')) })
                    .then(() => { this.isRefreshing = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/providers/Zapier.vue